var version = {
    "name":      "dativery",
    "buildDateCode": "20260824-143829",
    "buildDate": "Mon Aug 24 2026 14:38:29 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260824-143829",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;